import { render, staticRenderFns } from "./TrialResultBasicInfo.vue?vue&type=template&id=3a949a70&scoped=true"
import script from "./TrialResultBasicInfo.vue?vue&type=script&lang=js"
export * from "./TrialResultBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./TrialResultBasicInfo.vue?vue&type=style&index=0&id=3a949a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a949a70",
  null
  
)

export default component.exports